import { getStaffFullName } from 'utils/staff';
import { useTranslation } from 'hooks/useTranslation';
import { getQunoScoreStatus } from 'utils/qunoScore';
import { formatNumber } from 'utils/number';
import Accordion from 'components/ui/ContentBlocks/Accordion';
import QunoscoreBlock from './QunoscoreBlock';
import qunoscoreData from './qunoscoreData';
import QunoscoreRating from './QunoscoreRating';
import type { DoctorProfileEntry } from '.';

type Props = {
  entry: DoctorProfileEntry;
};

const QunoscoreSection = ({ entry }: Props): JSX.Element => {
  const { locale, t } = useTranslation();

  const qunoscore = entry?.qunoscoreDetails?.qunoscore?.['en-US'];
  const qunoscorePoints = entry?.qunoscoreDetails?.qunoscorePoints?.['en-US'];

  return (
    <div className="max-w-screen-xl mx-auto px-5 md:px-4 lg:grid md:grid-cols-3 md:mt-24">
      <div>
        <h2 className="adelle-bold-section-headline">
          {t('doctorProfile.qunoscore')}
        </h2>
        <div className="flex items-center mb-4">
          <QunoscoreRating rating={qunoscore} theme="transparent" />
          <div className="ml-3">
            <p className="font-bold text-lg text-right">
              {t(getQunoScoreStatus(qunoscore))}
            </p>
            <p className="uppercase text-xs">{t('doctorProfile.qunoscore')}</p>
          </div>
        </div>
        <>
          <p>
            {t('doctorProfile.qunoscoreSection.about', {
              doctorName: getStaffFullName(entry, locale),
              qunoscorePoints: (
                <span className="font-bold">
                  {t('doctorProfile.qunoscoreSection.about.points', {
                    points: qunoscorePoints,
                  })}
                </span>
              ),
              qunoscoreStatus: (
                <span className="font-bold">
                  {t('doctorProfile.qunoscoreSection.about.status', {
                    points: formatNumber(qunoscore, locale),
                    status: t(getQunoScoreStatus(qunoscore)),
                  })}
                </span>
              ),
            })}
          </p>
        </>
      </div>
      <div className="col-span-2 lg:pl-12">
        <p
          className="my-6 lg:mt-0"
          dangerouslySetInnerHTML={{
            __html: t('doctorProfile.qunoscoreSection.intro'),
          }}
        />
        <div className="md:flex mb-4">
          <div className="flex items-center mr-4">
            <span className="block w-4 h-4 md:w-6 md:h-6 rounded-full bg-light-green mr-2" />
            {t('doctorProfile.qunoscoreSection.higherStatus')}
          </div>
          <div className="flex items-center mr-4">
            <span className="block w-4 h-4 md:w-6 md:h-6 rounded-full bg-secondary mr-2" />
            {t('doctorProfile.qunoscoreSection.middleStatus')}
          </div>
          <div className="flex items-center">
            <span className="block w-4 h-4 md:w-6 md:h-6 rounded-full bg-light-red mr-2" />
            {t('doctorProfile.qunoscoreSection.lowerStatus')}
          </div>
        </div>
        <Accordion>
          {qunoscoreData.map((block, index) => (
            <QunoscoreBlock key={index} block={block} fields={entry} />
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default QunoscoreSection;
